import type { Partner } from "@expert/shared-types";
import type { AbstractAnalyticsDispatcher } from "@soluto-private/eventualize";

import { useQuery } from "@tanstack/react-query";

import type { CustomerDetailsPayload } from "@/customer-info";

import { getCustomerDetails } from "@/customer-info/api";
import { useLogger } from "@/sdk";

interface UseGetCustomerDetailsByBANParams {
    billingAccountNumber: string;
    pin: string;
    partner: Partner;
    dispatcher?: AbstractAnalyticsDispatcher;
    customerDetailsCallback?: (result: CustomerDetailsPayload) => void;
    mdn?: string;
}

export function useGetCustomerDetailsByBAN({
    billingAccountNumber,
    pin,
    partner,
    dispatcher,
    customerDetailsCallback,
    mdn,
}: UseGetCustomerDetailsByBANParams) {
    const logger = useLogger({ module: "useGetCustomerDetailsByBAN" });

    const { data, isLoading, refetch } = useQuery({
        queryKey: [`customer-details-${billingAccountNumber}-${pin}`, billingAccountNumber + pin],
        queryFn: async () => {
            return getCustomerDetails(logger, {
                billingAccountNumber,
                pin: pin.length > 0 ? pin : undefined,
                partner,
                searchType: "billingAccountNumberAndPin",
                dispatcher,
                customerDetailsCallback,
                modelResultsMdn: mdn,
            });
        },
        enabled: false,
        refetchOnMount: true,
    });

    return {
        data,
        isLoading,
        refetch,
    };
}
